import { fileUtil } from './file';
import { timeUtil } from './time';

export const Utils = {
	file: fileUtil,
	time: timeUtil,
};
